// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accounts/v1/accounts.proto" (package "c1.api.accounts.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.accounts.v1.ListAuthBackendsRequest
 */
export interface ListAuthBackendsRequest {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.ListAuthBackendsResponse
 */
export interface ListAuthBackendsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accounts.v1.AuthBackends auth_backends = 1
     */
    authBackends: AuthBackends[];
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetInstallationRequest
 */
export interface GetInstallationRequest {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetTenantRequest
 */
export interface GetTenantRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Installation
 */
export interface Installation {
    /**
     * @generated from protobuf field: string domain = 1
     */
    domain: string;
    /**
     * @generated from protobuf field: uint32 port = 2
     */
    port: number;
    /**
     * @generated from protobuf field: string accounts_domain = 3
     */
    accountsDomain: string;
    /**
     * @generated from protobuf field: uint32 accounts_port = 4
     */
    accountsPort: number;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Tenant
 */
export interface Tenant {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string domain = 2
     */
    domain: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.accounts.v1.Installation installation = 4
     */
    installation?: Installation;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Google
 */
export interface Google {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Microsoft
 */
export interface Microsoft {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Okta
 */
export interface Okta {
    /**
     * @generated from protobuf field: string domain = 1
     */
    domain: string;
    /**
     * @generated from protobuf field: string oidc_client_id = 3
     */
    oidcClientId: string;
    /**
     * @generated from protobuf field: string oidc_client_secret = 4
     */
    oidcClientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.OneLogin
 */
export interface OneLogin {
    /**
     * @generated from protobuf field: string domain = 1
     */
    domain: string;
    /**
     * @generated from protobuf field: string client_id = 2
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 3
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.JumpCloud
 */
export interface JumpCloud {
    /**
     * @generated from protobuf field: string client_id = 1
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 2
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.PingOne
 */
export interface PingOne {
    /**
     * @generated from protobuf field: string environment_id = 1
     */
    environmentId: string;
    /**
     * @generated from protobuf field: string client_id = 2
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 3
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.OIDC
 */
export interface OIDC {
    /**
     * @generated from protobuf field: string issuer_id = 1
     */
    issuerId: string;
    /**
     * @generated from protobuf field: string client_id = 2
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 3
     */
    clientSecret: string;
    /**
     * @generated from protobuf field: repeated string scopes = 4
     */
    scopes: string[];
    /**
     * @generated from protobuf field: map<string, string> exact_match_claims = 5
     */
    exactMatchClaims: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.accounts.v1.AuthBackend
 */
export interface AuthBackend {
    /**
     * @generated from protobuf oneof: auth_backend
     */
    authBackend: {
        oneofKind: "google";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.Google google = 100
         */
        google: Google;
    } | {
        oneofKind: "microsoft";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.Microsoft microsoft = 101
         */
        microsoft: Microsoft;
    } | {
        oneofKind: "okta";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.Okta okta = 102
         */
        okta: Okta;
    } | {
        oneofKind: "oneLogin";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.OneLogin one_login = 103
         */
        oneLogin: OneLogin;
    } | {
        oneofKind: "jumpCloud";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.JumpCloud jump_cloud = 104
         */
        jumpCloud: JumpCloud;
    } | {
        oneofKind: "pingOne";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.PingOne ping_one = 105
         */
        pingOne: PingOne;
    } | {
        oneofKind: "oidc";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.OIDC oidc = 106
         */
        oidc: OIDC;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accounts.v1.SignupRequest
 */
export interface SignupRequest {
    /**
     * @generated from protobuf field: string domain = 1
     */
    domain: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string invite_code = 3
     */
    inviteCode: string;
    /**
     * @generated from protobuf field: c1.api.accounts.v1.AuthBackend auth_backend = 4
     */
    authBackend?: AuthBackend;
    /**
     * @generated from protobuf field: bool accepted_terms = 5
     */
    acceptedTerms: boolean;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.SignupResponse
 */
export interface SignupResponse {
    /**
     * @generated from protobuf field: string redirect_uri = 1
     */
    redirectUri: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetRUMRequest
 */
export interface GetRUMRequest {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetRUMResponse
 */
export interface GetRUMResponse {
    /**
     * @generated from protobuf field: string datadog_rum_app_id = 1
     */
    datadogRumAppId: string;
    /**
     * @generated from protobuf field: string datadog_rum_client_token = 2
     */
    datadogRumClientToken: string;
    /**
     * @generated from protobuf field: string datadog_site = 3
     */
    datadogSite: string;
    /**
     * @generated from protobuf field: string datadog_rum_env = 4
     */
    datadogRumEnv: string;
}
/**
 * @generated from protobuf enum c1.api.accounts.v1.AuthBackends
 */
export enum AuthBackends {
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_UNKNOWN = 0;
     */
    AUTH_BACKEND_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_GOOGLE = 1;
     */
    AUTH_BACKEND_GOOGLE = 1,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_MICROSOFT = 2;
     */
    AUTH_BACKEND_MICROSOFT = 2,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_OKTA = 3;
     */
    AUTH_BACKEND_OKTA = 3,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_ONELOGIN = 4;
     */
    AUTH_BACKEND_ONELOGIN = 4,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_JUMPCLOUD = 5;
     */
    AUTH_BACKEND_JUMPCLOUD = 5,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_PINGONE = 6;
     */
    AUTH_BACKEND_PINGONE = 6,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_OIDC = 7;
     */
    AUTH_BACKEND_OIDC = 7
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthBackendsRequest$Type extends MessageType<ListAuthBackendsRequest> {
    constructor() {
        super("c1.api.accounts.v1.ListAuthBackendsRequest", []);
    }
    create(value?: PartialMessage<ListAuthBackendsRequest>): ListAuthBackendsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAuthBackendsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAuthBackendsRequest): ListAuthBackendsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAuthBackendsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.ListAuthBackendsRequest
 */
export const ListAuthBackendsRequest = new ListAuthBackendsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthBackendsResponse$Type extends MessageType<ListAuthBackendsResponse> {
    constructor() {
        super("c1.api.accounts.v1.ListAuthBackendsResponse", [
            { no: 1, name: "auth_backends", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accounts.v1.AuthBackends", AuthBackends] }
        ]);
    }
    create(value?: PartialMessage<ListAuthBackendsResponse>): ListAuthBackendsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authBackends = [];
        if (value !== undefined)
            reflectionMergePartial<ListAuthBackendsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAuthBackendsResponse): ListAuthBackendsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accounts.v1.AuthBackends auth_backends */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.authBackends.push(reader.int32());
                    else
                        message.authBackends.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAuthBackendsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accounts.v1.AuthBackends auth_backends = 1; */
        if (message.authBackends.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.authBackends.length; i++)
                writer.int32(message.authBackends[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.ListAuthBackendsResponse
 */
export const ListAuthBackendsResponse = new ListAuthBackendsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInstallationRequest$Type extends MessageType<GetInstallationRequest> {
    constructor() {
        super("c1.api.accounts.v1.GetInstallationRequest", []);
    }
    create(value?: PartialMessage<GetInstallationRequest>): GetInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInstallationRequest): GetInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetInstallationRequest
 */
export const GetInstallationRequest = new GetInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTenantRequest$Type extends MessageType<GetTenantRequest> {
    constructor() {
        super("c1.api.accounts.v1.GetTenantRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "254" } } } }
        ]);
    }
    create(value?: PartialMessage<GetTenantRequest>): GetTenantRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<GetTenantRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTenantRequest): GetTenantRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTenantRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetTenantRequest
 */
export const GetTenantRequest = new GetTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Installation$Type extends MessageType<Installation> {
    constructor() {
        super("c1.api.accounts.v1.Installation", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "port", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "accounts_domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "accounts_port", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Installation>): Installation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        message.port = 0;
        message.accountsDomain = "";
        message.accountsPort = 0;
        if (value !== undefined)
            reflectionMergePartial<Installation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Installation): Installation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string domain */ 1:
                    message.domain = reader.string();
                    break;
                case /* uint32 port */ 2:
                    message.port = reader.uint32();
                    break;
                case /* string accounts_domain */ 3:
                    message.accountsDomain = reader.string();
                    break;
                case /* uint32 accounts_port */ 4:
                    message.accountsPort = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Installation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string domain = 1; */
        if (message.domain !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.domain);
        /* uint32 port = 2; */
        if (message.port !== 0)
            writer.tag(2, WireType.Varint).uint32(message.port);
        /* string accounts_domain = 3; */
        if (message.accountsDomain !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accountsDomain);
        /* uint32 accounts_port = 4; */
        if (message.accountsPort !== 0)
            writer.tag(4, WireType.Varint).uint32(message.accountsPort);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Installation
 */
export const Installation = new Installation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Tenant$Type extends MessageType<Tenant> {
    constructor() {
        super("c1.api.accounts.v1.Tenant", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "installation", kind: "message", T: () => Installation }
        ]);
    }
    create(value?: PartialMessage<Tenant>): Tenant {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.domain = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<Tenant>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Tenant): Tenant {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string domain */ 2:
                    message.domain = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.accounts.v1.Installation installation */ 4:
                    message.installation = Installation.internalBinaryRead(reader, reader.uint32(), options, message.installation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Tenant, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string domain = 2; */
        if (message.domain !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.domain);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.accounts.v1.Installation installation = 4; */
        if (message.installation)
            Installation.internalBinaryWrite(message.installation, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Tenant
 */
export const Tenant = new Tenant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Google$Type extends MessageType<Google> {
    constructor() {
        super("c1.api.accounts.v1.Google", []);
    }
    create(value?: PartialMessage<Google>): Google {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Google>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Google): Google {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Google, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Google
 */
export const Google = new Google$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Microsoft$Type extends MessageType<Microsoft> {
    constructor() {
        super("c1.api.accounts.v1.Microsoft", []);
    }
    create(value?: PartialMessage<Microsoft>): Microsoft {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Microsoft>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Microsoft): Microsoft {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Microsoft, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Microsoft
 */
export const Microsoft = new Microsoft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Okta$Type extends MessageType<Okta> {
    constructor() {
        super("c1.api.accounts.v1.Okta", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "300" } } } },
            { no: 3, name: "oidc_client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 4, name: "oidc_client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<Okta>): Okta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        message.oidcClientId = "";
        message.oidcClientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<Okta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Okta): Okta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string domain */ 1:
                    message.domain = reader.string();
                    break;
                case /* string oidc_client_id */ 3:
                    message.oidcClientId = reader.string();
                    break;
                case /* string oidc_client_secret */ 4:
                    message.oidcClientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Okta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string domain = 1; */
        if (message.domain !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.domain);
        /* string oidc_client_id = 3; */
        if (message.oidcClientId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.oidcClientId);
        /* string oidc_client_secret = 4; */
        if (message.oidcClientSecret !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.oidcClientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Okta
 */
export const Okta = new Okta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OneLogin$Type extends MessageType<OneLogin> {
    constructor() {
        super("c1.api.accounts.v1.OneLogin", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "300" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<OneLogin>): OneLogin {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        message.clientId = "";
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<OneLogin>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OneLogin): OneLogin {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string domain */ 1:
                    message.domain = reader.string();
                    break;
                case /* string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string client_secret */ 3:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OneLogin, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string domain = 1; */
        if (message.domain !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.domain);
        /* string client_id = 2; */
        if (message.clientId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string client_secret = 3; */
        if (message.clientSecret !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.OneLogin
 */
export const OneLogin = new OneLogin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JumpCloud$Type extends MessageType<JumpCloud> {
    constructor() {
        super("c1.api.accounts.v1.JumpCloud", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<JumpCloud>): JumpCloud {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientId = "";
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<JumpCloud>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JumpCloud): JumpCloud {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_id */ 1:
                    message.clientId = reader.string();
                    break;
                case /* string client_secret */ 2:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JumpCloud, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_id = 1; */
        if (message.clientId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientId);
        /* string client_secret = 2; */
        if (message.clientSecret !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.JumpCloud
 */
export const JumpCloud = new JumpCloud$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingOne$Type extends MessageType<PingOne> {
    constructor() {
        super("c1.api.accounts.v1.PingOne", [
            { no: 1, name: "environment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<PingOne>): PingOne {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.environmentId = "";
        message.clientId = "";
        message.clientSecret = "";
        if (value !== undefined)
            reflectionMergePartial<PingOne>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PingOne): PingOne {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string environment_id */ 1:
                    message.environmentId = reader.string();
                    break;
                case /* string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string client_secret */ 3:
                    message.clientSecret = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PingOne, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string environment_id = 1; */
        if (message.environmentId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.environmentId);
        /* string client_id = 2; */
        if (message.clientId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string client_secret = 3; */
        if (message.clientSecret !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientSecret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.PingOne
 */
export const PingOne = new PingOne$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OIDC$Type extends MessageType<OIDC> {
    constructor() {
        super("c1.api.accounts.v1.OIDC", [
            { no: 1, name: "issuer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } },
            { no: 4, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16", unique: true } } } },
            { no: 5, name: "exact_match_claims", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "validate.rules": { map: { maxPairs: "16", keys: { string: { minBytes: "3", maxBytes: "256" } }, values: { string: { minBytes: "3", maxBytes: "256" } } } } } }
        ]);
    }
    create(value?: PartialMessage<OIDC>): OIDC {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.issuerId = "";
        message.clientId = "";
        message.clientSecret = "";
        message.scopes = [];
        message.exactMatchClaims = {};
        if (value !== undefined)
            reflectionMergePartial<OIDC>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OIDC): OIDC {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string issuer_id */ 1:
                    message.issuerId = reader.string();
                    break;
                case /* string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string client_secret */ 3:
                    message.clientSecret = reader.string();
                    break;
                case /* repeated string scopes */ 4:
                    message.scopes.push(reader.string());
                    break;
                case /* map<string, string> exact_match_claims */ 5:
                    this.binaryReadMap5(message.exactMatchClaims, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: OIDC["exactMatchClaims"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof OIDC["exactMatchClaims"] | undefined, val: OIDC["exactMatchClaims"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accounts.v1.OIDC.exact_match_claims");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: OIDC, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string issuer_id = 1; */
        if (message.issuerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.issuerId);
        /* string client_id = 2; */
        if (message.clientId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string client_secret = 3; */
        if (message.clientSecret !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientSecret);
        /* repeated string scopes = 4; */
        for (let i = 0; i < message.scopes.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.scopes[i]);
        /* map<string, string> exact_match_claims = 5; */
        for (let k of globalThis.Object.keys(message.exactMatchClaims))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.exactMatchClaims[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.OIDC
 */
export const OIDC = new OIDC$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBackend$Type extends MessageType<AuthBackend> {
    constructor() {
        super("c1.api.accounts.v1.AuthBackend", [
            { no: 100, name: "google", kind: "message", oneof: "authBackend", T: () => Google },
            { no: 101, name: "microsoft", kind: "message", oneof: "authBackend", T: () => Microsoft },
            { no: 102, name: "okta", kind: "message", oneof: "authBackend", T: () => Okta },
            { no: 103, name: "one_login", kind: "message", oneof: "authBackend", T: () => OneLogin },
            { no: 104, name: "jump_cloud", kind: "message", oneof: "authBackend", T: () => JumpCloud },
            { no: 105, name: "ping_one", kind: "message", oneof: "authBackend", T: () => PingOne },
            { no: 106, name: "oidc", kind: "message", oneof: "authBackend", T: () => OIDC }
        ]);
    }
    create(value?: PartialMessage<AuthBackend>): AuthBackend {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authBackend = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AuthBackend>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthBackend): AuthBackend {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accounts.v1.Google google */ 100:
                    message.authBackend = {
                        oneofKind: "google",
                        google: Google.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).google)
                    };
                    break;
                case /* c1.api.accounts.v1.Microsoft microsoft */ 101:
                    message.authBackend = {
                        oneofKind: "microsoft",
                        microsoft: Microsoft.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).microsoft)
                    };
                    break;
                case /* c1.api.accounts.v1.Okta okta */ 102:
                    message.authBackend = {
                        oneofKind: "okta",
                        okta: Okta.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).okta)
                    };
                    break;
                case /* c1.api.accounts.v1.OneLogin one_login */ 103:
                    message.authBackend = {
                        oneofKind: "oneLogin",
                        oneLogin: OneLogin.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).oneLogin)
                    };
                    break;
                case /* c1.api.accounts.v1.JumpCloud jump_cloud */ 104:
                    message.authBackend = {
                        oneofKind: "jumpCloud",
                        jumpCloud: JumpCloud.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).jumpCloud)
                    };
                    break;
                case /* c1.api.accounts.v1.PingOne ping_one */ 105:
                    message.authBackend = {
                        oneofKind: "pingOne",
                        pingOne: PingOne.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).pingOne)
                    };
                    break;
                case /* c1.api.accounts.v1.OIDC oidc */ 106:
                    message.authBackend = {
                        oneofKind: "oidc",
                        oidc: OIDC.internalBinaryRead(reader, reader.uint32(), options, (message.authBackend as any).oidc)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthBackend, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accounts.v1.Google google = 100; */
        if (message.authBackend.oneofKind === "google")
            Google.internalBinaryWrite(message.authBackend.google, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accounts.v1.Microsoft microsoft = 101; */
        if (message.authBackend.oneofKind === "microsoft")
            Microsoft.internalBinaryWrite(message.authBackend.microsoft, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accounts.v1.Okta okta = 102; */
        if (message.authBackend.oneofKind === "okta")
            Okta.internalBinaryWrite(message.authBackend.okta, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accounts.v1.OneLogin one_login = 103; */
        if (message.authBackend.oneofKind === "oneLogin")
            OneLogin.internalBinaryWrite(message.authBackend.oneLogin, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accounts.v1.JumpCloud jump_cloud = 104; */
        if (message.authBackend.oneofKind === "jumpCloud")
            JumpCloud.internalBinaryWrite(message.authBackend.jumpCloud, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accounts.v1.PingOne ping_one = 105; */
        if (message.authBackend.oneofKind === "pingOne")
            PingOne.internalBinaryWrite(message.authBackend.pingOne, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accounts.v1.OIDC oidc = 106; */
        if (message.authBackend.oneofKind === "oidc")
            OIDC.internalBinaryWrite(message.authBackend.oidc, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.AuthBackend
 */
export const AuthBackend = new AuthBackend$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignupRequest$Type extends MessageType<SignupRequest> {
    constructor() {
        super("c1.api.accounts.v1.SignupRequest", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "63", hostname: true } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "63" } } } },
            { no: 3, name: "invite_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9-]{8,64}$" } } } },
            { no: 4, name: "auth_backend", kind: "message", T: () => AuthBackend, options: { "validate.rules": { message: { required: true } } } },
            { no: 5, name: "accepted_terms", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SignupRequest>): SignupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        message.displayName = "";
        message.inviteCode = "";
        message.acceptedTerms = false;
        if (value !== undefined)
            reflectionMergePartial<SignupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SignupRequest): SignupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string domain */ 1:
                    message.domain = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string invite_code */ 3:
                    message.inviteCode = reader.string();
                    break;
                case /* c1.api.accounts.v1.AuthBackend auth_backend */ 4:
                    message.authBackend = AuthBackend.internalBinaryRead(reader, reader.uint32(), options, message.authBackend);
                    break;
                case /* bool accepted_terms */ 5:
                    message.acceptedTerms = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SignupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string domain = 1; */
        if (message.domain !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.domain);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string invite_code = 3; */
        if (message.inviteCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.inviteCode);
        /* c1.api.accounts.v1.AuthBackend auth_backend = 4; */
        if (message.authBackend)
            AuthBackend.internalBinaryWrite(message.authBackend, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool accepted_terms = 5; */
        if (message.acceptedTerms !== false)
            writer.tag(5, WireType.Varint).bool(message.acceptedTerms);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.SignupRequest
 */
export const SignupRequest = new SignupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignupResponse$Type extends MessageType<SignupResponse> {
    constructor() {
        super("c1.api.accounts.v1.SignupResponse", [
            { no: 1, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SignupResponse>): SignupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.redirectUri = "";
        if (value !== undefined)
            reflectionMergePartial<SignupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SignupResponse): SignupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string redirect_uri */ 1:
                    message.redirectUri = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SignupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string redirect_uri = 1; */
        if (message.redirectUri !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.redirectUri);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.SignupResponse
 */
export const SignupResponse = new SignupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMRequest$Type extends MessageType<GetRUMRequest> {
    constructor() {
        super("c1.api.accounts.v1.GetRUMRequest", []);
    }
    create(value?: PartialMessage<GetRUMRequest>): GetRUMRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetRUMRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRUMRequest): GetRUMRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRUMRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetRUMRequest
 */
export const GetRUMRequest = new GetRUMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMResponse$Type extends MessageType<GetRUMResponse> {
    constructor() {
        super("c1.api.accounts.v1.GetRUMResponse", [
            { no: 1, name: "datadog_rum_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "datadog_rum_client_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "datadog_site", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "datadog_rum_env", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetRUMResponse>): GetRUMResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.datadogRumAppId = "";
        message.datadogRumClientToken = "";
        message.datadogSite = "";
        message.datadogRumEnv = "";
        if (value !== undefined)
            reflectionMergePartial<GetRUMResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRUMResponse): GetRUMResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string datadog_rum_app_id */ 1:
                    message.datadogRumAppId = reader.string();
                    break;
                case /* string datadog_rum_client_token */ 2:
                    message.datadogRumClientToken = reader.string();
                    break;
                case /* string datadog_site */ 3:
                    message.datadogSite = reader.string();
                    break;
                case /* string datadog_rum_env */ 4:
                    message.datadogRumEnv = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRUMResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string datadog_rum_app_id = 1; */
        if (message.datadogRumAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.datadogRumAppId);
        /* string datadog_rum_client_token = 2; */
        if (message.datadogRumClientToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.datadogRumClientToken);
        /* string datadog_site = 3; */
        if (message.datadogSite !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.datadogSite);
        /* string datadog_rum_env = 4; */
        if (message.datadogRumEnv !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.datadogRumEnv);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetRUMResponse
 */
export const GetRUMResponse = new GetRUMResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accounts.v1.Accounts
 */
export const Accounts = new ServiceType("c1.api.accounts.v1.Accounts", [
    { name: "ListAuthBackends", options: {}, I: ListAuthBackendsRequest, O: ListAuthBackendsResponse },
    { name: "GetInstallation", options: {}, I: GetInstallationRequest, O: Installation },
    { name: "GetTenant", options: {}, I: GetTenantRequest, O: Tenant },
    { name: "Signup", options: {}, I: SignupRequest, O: SignupResponse },
    { name: "GetRUM", options: {}, I: GetRUMRequest, O: GetRUMResponse }
], { "authz.service": { disabled: true } });
